import { createRoot } from 'react-dom/client'
import Root from './containers'

import 'antd/dist/reset.css'
import './index.scss'

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(<Root />)
